export const REGISTRATION_CHANGE_REASONS = ['to_private_plate', 'to_original_plate', 'correction'] as const;
export type RegistrationChangeReason = (typeof REGISTRATION_CHANGE_REASONS)[number];

export const MILEAGE_CHANGE_REASONS = ['invoice_submitted', 'invoice_reversed'] as const;
export type MileageChangeReason = (typeof MILEAGE_CHANGE_REASONS)[number];

export const VEHICLE_AMENDMENT_TYPES = ['registration', 'mileage'] as const;
export type VehicleAmendmentType = (typeof VEHICLE_AMENDMENT_TYPES)[number];

/** Mapped off the shipped GET /vehicles/{id}/status row, which may itself be null.
 *  `vrm` is null when there is no current status row or the row's plate is unknown. */
export interface VehicleRegistration {
    vehicleId: string;
    vrm: string | null;
    recordedAt: string | null;
}

/** `mileage` is a non-negative integer or null; null means there is nothing to check against. */
export interface VehicleMileage {
    vehicleId: string;
    mileage: number | null;
    recordedOn: string | null;
}

/** One shape for every amendment class, so the log renders a type it has never seen
 *  without a code change. Every enum-shaped read field widens to `| string`. */
export interface VehicleAmendment {
    id: string;
    amendmentType: VehicleAmendmentType | string;
    reason: RegistrationChangeReason | string | null;
    agreementId: string;
    vehicleStatusId: string | null;
    /** Derived server-side from new_values; never re-derived on the client. */
    changedFields: string[];
    oldValues: Record<string, string | null>;
    newValues: Record<string, string | null>;
    recordedAt: string;
    actorType: string | null;
    actorId: string | null;
    actorName: string | null;
}

export interface VehicleAmendmentsPage {
    amendments: VehicleAmendment[];
    meta: { currentPage: number; lastPage: number; perPage: number; total: number };
}

/** The door's input stays registration-specific: one specific door, one generic record. */
export interface ChangeRegistrationInput {
    newVrm: string;
    reason: RegistrationChangeReason;
    sameVehicleConfirmed: true;
    agreementId: string;
}
